import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  IconButton,
  Tooltip,
  CircularProgress,
  Box,
  Button,
  Grid,
} from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import { Pagination } from "@material-ui/lab";

import { connect } from "react-redux";
import { getDaftarReimburse } from "../../../../store/actions";

import { TableHead, Dialog } from "./component";
import { capitalize, moneyFormat } from "../../../../shared/utility";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },

  btnConfirm: {
    color: theme.palette.success.main,
  },

  btnCancel: {
    color: theme.palette.error.main,
  },

  btnDisabled: {
    color: "#b4b4b4",
  },
  pagination: {
    padding: theme.spacing(0.5),
    "& .MuiPagination-ul": {
      justifyContent: "center",
    },
  },
}));

const TableDaftarReimburse = ({
  reimburse,
  getDaftarReimburse,
  setDialog,
  auth,
  entitas,
  status,
  year,
}) => {
  const classes = useStyles();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [dialogImage, setDialogImage] = useState({
    open: false,
    path: null,
  });

  const handlePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleOpenDialog = (path) => {
    setDialogImage({
      open: true,
      path: path,
    });
  };

  useEffect(() => {
    if (auth.user.role_name === "hcis") {
      getDaftarReimburse(true, entitas, status, year, page, rowsPerPage);
    } else {
      getDaftarReimburse(false, entitas, status, year, page, rowsPerPage);
    }
  }, [page, rowsPerPage]);

  useEffect(() => {
    setPage(1);
    if (auth.user.role_name === "hcis") {
      getDaftarReimburse(true, entitas, status, year, page, rowsPerPage);
    } else {
      getDaftarReimburse(false, entitas, status, year, page, rowsPerPage);
    }
  }, [entitas, status, year]);

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            aria-label="enhanced table"
          >
            <TableHead />
            <TableBody>
              {reimburse.loading ? (
                <TableRow>
                  <TableCell align="center" colSpan={10}>
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : reimburse.allData.length > 0 ? (
                reimburse.allData.map((row, index) => {
                  return (
                    <TableRow tabIndex={-1} key={index + 1}>
                      <TableCell>
                        {index + 1 + (page - 1) * rowsPerPage}
                      </TableCell>
                      <TableCell>{row.user_name}</TableCell>
                      <TableCell>{row.company_name}</TableCell>
                      <TableCell>{row.reimburse_date}</TableCell>
                      <TableCell>{row.created_at}</TableCell>
                      <TableCell>{row.description}</TableCell>
                      <TableCell>{moneyFormat(row.total)}</TableCell>
                      <TableCell>
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          onClick={() => {
                            handleOpenDialog(row.path);
                          }}
                        >
                          Lihat Kwitansi
                        </Button>
                      </TableCell>
                      <TableCell>{capitalize(row.status)}</TableCell>
                      <TableCell>{row.action_by}</TableCell>
                      <TableCell>
                        {row.status === "disetujui" &&
                        auth.user.role_name === "hcis" &&
                        auth.user.job_name === "Staff Finance" ? (
                          <Button
                            variant="contained"
                            color="secondary"
                            size="small"
                            onClick={() => {
                              setDialog({
                                open: true,
                                value: row,
                                type: "transfer",
                              });
                            }}
                          >
                            Transfer
                          </Button>
                        ) : row.status === "transfer" ||
                          row.status === "ditolak" ||
                          row.status === "disetujui" ? (
                          <Box display="flex">
                            <IconButton
                              disabled
                              variant="contained"
                              color="primary"
                            >
                              <CheckCircleIcon
                                className={classes.btnDisabled}
                              />
                            </IconButton>
                            <IconButton
                              disabled
                              variant="contained"
                              color="secondary"
                            >
                              <CancelIcon className={classes.btnDisabled} />
                            </IconButton>
                          </Box>
                        ) : auth.user.sequence === 1 || row.can_action ? (
                          <Box display="flex">
                            <Tooltip title="Confirm">
                              <IconButton
                                onClick={() => {
                                  setDialog({
                                    open: true,
                                    value: row,
                                    type: "confirm",
                                  });
                                }}
                                variant="contained"
                                color="primary"
                              >
                                <CheckCircleIcon
                                  className={classes.btnConfirm}
                                />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Cancel">
                              <IconButton
                                onClick={() => {
                                  setDialog({
                                    open: true,
                                    value: row,
                                    type: "rejected",
                                  });
                                }}
                                variant="contained"
                                color="secondary"
                              >
                                <CancelIcon className={classes.btnCancel} />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        ) : (
                          <Box display="flex">
                            <IconButton
                              disabled
                              variant="contained"
                              color="primary"
                            >
                              <CheckCircleIcon
                                className={classes.btnDisabled}
                              />
                            </IconButton>
                            <IconButton
                              disabled
                              variant="contained"
                              color="secondary"
                            >
                              <CancelIcon className={classes.btnDisabled} />
                            </IconButton>
                          </Box>
                        )}
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell align="center" colSpan={10}>
                    Data Kosong
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <Grid
          container
          justify="center"
          alignItems="center"
          className={classes.pagination}
        >
          <Grid item xs={8}>
            <Pagination
              className={classes.pagination}
              count={reimburse.last_page}
              page={page}
              onChange={handlePage}
              color="primary"
            />
          </Grid>
        </Grid>
      </Paper>
      <Dialog
        dialog={dialogImage}
        onClose={() => {
          setDialogImage({
            open: false,
            path: null,
          });
        }}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    reimburse: state.reimburse,
  };
};

export default connect(mapStateToProps, { getDaftarReimburse })(
  TableDaftarReimburse
);
